// extracted by mini-css-extract-plugin
export default {"logo":"LogoWithName_logo__CUD+J","imgWhite":"LogoWithName_imgWhite__zLNuE","imgBlack":"LogoWithName_imgBlack__OmXuI","white":"LogoWithName_white__qtz37"};